import { render, staticRenderFns } from "./EditArticle.vue?vue&type=template&id=c7db7a98&scoped=true&"
import script from "./EditArticle.vue?vue&type=script&lang=js&"
export * from "./EditArticle.vue?vue&type=script&lang=js&"
import style0 from "./EditArticle.vue?vue&type=style&index=0&id=c7db7a98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7db7a98",
  null
  
)

export default component.exports